<div class="card text-white bg-danger mb-3" style="max-width: 80%; margin: 20px auto;">
  <div class="card-header">{{'ERROR' | translate}}
      <button type="button" class="btn btn-warning float-left" (click)="return()">{{'LOGIN' | translate}}</button>
  </div>
  <div class="card-body text-dark bg-white">
    <h5 class="card-title">{{errorMsg}}</h5>
  </div>
</div>